import IconArrowLeftNoBrand from 'assets/icons/iconArrowLeftNoBrand.svg'
import * as Common from 'components/common/Common'
import { TButtonClickHandler } from 'components/common/commonStyles'
import * as Typography from 'components/common/Typography'
import { useTranslation } from 'react-i18next'

const BackButton = ({ onClick }: { onClick: TButtonClickHandler }) => {
  const { t } = useTranslation()

  return (
    <Common.Div
      flex="row"
      gap="8px"
      alignItems="center"
      onClick={onClick}
    >
      <Common.SvgIcon src={IconArrowLeftNoBrand} />

      <Typography.Body2 secondary>{t('navigation.back')}</Typography.Body2>
    </Common.Div>
  )
}

export default BackButton
